import { render } from "./VideoVerificationFailure.vue?vue&type=template&id=1dddeec2&scoped=true"
import script from "./VideoVerificationFailure.vue?vue&type=script&lang=js"
export * from "./VideoVerificationFailure.vue?vue&type=script&lang=js"

import "./VideoVerificationFailure.vue?vue&type=style&index=0&id=1dddeec2&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dddeec2"]])

export default __exports__